<template>
<app-base-main style="padding-top: 6px">
  <template #base-content>
  <gj-app-top-tabs v-model="tabActive"
    :tabs="tabs">
    <keep-alive>
      <component :is="tabActive"></component>
    </keep-alive>
  </gj-app-top-tabs>
  </template>
</app-base-main>
</template>

<script>
import asin from './widget/widget-ASIN'
import variationAsin from './widget/widget-FASIN'
import msku from './widget/widget-MSKU'
import SHOP from './widget/widget-SHOP'
const TAB_CACHE_KEY =  `PROFIT_STATISTICS_TABS`
import GjAppTopTabs from '@/views/modules/statistics/profit-statistics-copy/components/app-top-tabs.vue'
export default {
  name:"profit-statistics",
  components:{asin,variationAsin,msku,SHOP,GjAppTopTabs},
  data() {
    return {
      tabs:[
        {id: 'msku', text: 'MSKU'},
        {id: 'asin', text: 'ASIN',},
        {id: 'variationAsin', text: '父ASIN'},
        {id: 'SHOP', text: '店铺'},
      ],
      tabActive: 'msku',
      timeStamp: null
    }
  },
  created () {
    // 新打开是，若是从首页看板跳转，根据首页维度切换tab
    if(this.$route.query.timeStamp!=this.timeStamp){
      this.tabActive = this.$route.query.routeKey;
      this.timeStamp = this.$route.query.timeStamp;
    }
    // 否则，从缓存取tab
    else {
      this.getRemoteCacheTab()
    }
  },
  activated() {
    // 从首页看板跳转时，根据首页维度切换tab
    if (this.$route.query.timeStamp != this.timeStamp) {
      this.tabActive = this.$route.query.routeKey;
      this.timeStamp = this.$route.query.timeStamp;
    }
  },
  methods: {
    async getRemoteCacheTab() {
      const tabCache = await this.$cache.getCache(TAB_CACHE_KEY)
      if (tabCache && tabCache.params) {
        try {
          const {tabActive} = JSON.parse(tabCache.params)
          this.tabActive = tabActive
        } catch (e) {
          console.warn(e)
        }
      } else {
        this.tabActive = 'msku'
      }
    }
  },
  // 离开页面 缓存当前的active
  beforeDestroy () {
    this.$cache.setCache(TAB_CACHE_KEY, { tabActive: this.tabActive })
  }
}
</script>

<style lang="scss" scoped>
  /deep/ .tabs-header{
    margin-bottom: 12px;
    height: 31px;
  }
  /deep/ .profit-statistics-widget-msku{
    padding: 0;
  }
  /deep/ .base-content{
    height: 100%;
    .gj-top-tabs-box{
      display: flex;
      flex-direction: column;
    }
    .tabs-content{
      flex: 1;
      overflow: auto;
    }
  }
</style>